export default "__VITE_ASSET__Whp13dJ7__"